// extracted by mini-css-extract-plugin
export default {"faqModal":"LockerModal_faqModal__AHgD1","closeBtn":"LockerModal_closeBtn__8m9-t","faqItem":"LockerModal_faqItem__lmRyA","scaleIn":"LockerModal_scaleIn__cJj42"};